var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaveProductoServicio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404040"
    },
    d: "M336,160h-16V96c0-4.8,3.2-8,8-8h16V40h-32v24c0,4.8-3.2,8-8,8h-32V56h24V32c0-4.8,3.2-8,8-8h48 c4.8,0,8,3.2,8,8v64c0,4.8-3.2,8-8,8h-16V160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F2B1D"
    },
    d: "M304,208v-32c0-13.6,10.4-24,24-24l0,0c13.6,0,24,10.4,24,24v32"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#A6A6A6"
    },
    width: 272,
    height: 176
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    style: {
      fill: "#737272"
    },
    width: 208,
    height: 48
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#737272"
    },
    points: "176,208 176,448 136,480 96,448 96,432 112,416 112,400 96,384 96,368 112,352 112,336  96,320 96,304 112,288 112,272 96,256 96,208  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#A6A6A6"
    },
    points: "64,176 64,208 208,208 208,176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A6A6A6"
    },
    points: "152,467.2 136,480 136,232 152,232  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 208,
    style: {
      fill: "#BF412C"
    },
    width: 176,
    height: 272
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 416,
    style: {
      fill: "#7F2B1D"
    },
    width: 176,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 304,
    style: {
      fill: "#7F2B1D"
    },
    width: 112,
    height: 80
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7F2B1D"
    },
    cx: 392,
    cy: 256,
    r: 16
  })), /*#__PURE__*/React.createElement("rect", {
    y: 144,
    style: {
      fill: "#737272"
    },
    width: 272,
    height: 32
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaveProductoServicio);
export default __webpack_public_path__ + "static/media/clave_producto_servicio.e6aafe76660b63c218e514e76943eb24.svg";
export { ForwardRef as ReactComponent };